import cookie from './cookie';

const getMasqueradeFromCookie = () => {
  let masquerade = cookie.get('masquerade_user') || '{}';
  if (masquerade && typeof masquerade === 'string') {
    masquerade = JSON.parse(masquerade);
  }
  return masquerade;
};

const getCookie = cookieName => {
  const masquerade = getMasqueradeFromCookie();
  if (masquerade[cookieName]) {
    return masquerade[cookieName];
  }
  return cookie.get(cookieName);
};

const user = {
  token: () => getCookie('lyearn_token') || getCookie('access_token'),
  email: () => getCookie('email'),
  name: () => getCookie('name'),
  id: () => getCookie('user_id'),
  companyId: () => getCookie('companyId'),
  parentCompanyId: () => getCookie('parentCompanyId'),
  picture: () => getCookie('picture'),
  roles: () => getCookie('roles'),
  aToken: () => getCookie('lyearn_token') || getCookie('access_token'),
  isMasqueraded: () => {
    const masquerade = getMasqueradeFromCookie();
    return masquerade && !!masquerade.user_id;
  },
  isGuest: () => getCookie('isGuest'),
  getMasqueradedObject: getMasqueradeFromCookie
};

export { user };

export default class CurrentUser {
  constructor() {
    const userObj = {};
    userObj.email = cookie.get('email');
    userObj.name = cookie.get('name');
    userObj.companyId = cookie.get('companyId');
    userObj.parentCompanyId = cookie.get('parentCompanyId');
    userObj.picture = cookie.get('picture');
    userObj.id = cookie.get('user_id');
    userObj.aToken = cookie.get('access_token');
    userObj.roles = cookie.get('roles');
    this.user = userObj;
  }

  get = () => this.user;

  token = () => getCookie('lyearn_token') || getCookie('access_token');

  email = () => getCookie('email');

  name = () => getCookie('name');

  id = () => getCookie('user_id');

  companyId = () => getCookie('companyId');

  parentCompanyId = () => getCookie('parentCompanyId');

  picture = () => getCookie('picture');

  roles = () => getCookie('roles');

  aToken = () => getCookie('lyearn_token') || getCookie('access_token');

  loginMode = () => getCookie('loginMode');

  getCookieByName = cookieName => getCookie(cookieName);

  isMasqueraded = () => {
    const masquerade = getMasqueradeFromCookie();
    return masquerade && !!masquerade.user_id;
  };

  isGuest = () => getCookie('isGuest');

  getMasqueradedObject = getMasqueradeFromCookie;
}
